import { useEffect } from 'react'

/**
 * Pins the light token scope on <html> while the calling page is mounted.
 *
 * The sign-in and onboarding pages are a fixed dark-brand / light-form composition
 * (handoff/02-auth-onboarding SPEC: dark mode is dropped on these pages only).
 * ThemeProvider applies `.dark` from the stored or system preference; the observer
 * re-asserts light if it does so after mount. The previous theme is restored on unmount.
 */
export function usePinnedLightTheme(): void {
  useEffect(() => {
    const root = document.documentElement
    const hadDark = root.classList.contains('dark')
    const applyLight = () => {
      root.classList.remove('dark')
      root.classList.add('light')
    }
    applyLight()
    const observer = new MutationObserver(() => {
      if (root.classList.contains('dark')) applyLight()
    })
    observer.observe(root, { attributes: true, attributeFilter: ['class'] })
    return () => {
      observer.disconnect()
      if (hadDark) {
        root.classList.remove('light')
        root.classList.add('dark')
      }
    }
  }, [])
}
